import { ACTION_TYPES } from "lib/Constants";

const {
  LOAD_MARKETPLACE_VENDOR_LIST_REQUEST,
  LOAD_MARKETPLACE_VENDOR_LIST_SUCCESS,
  LOAD_MARKETPLACE_VENDOR_LIST_ERROR,
  LOAD_MARKETPLACE_VENDOR_TYPE_SUCCESS,
  LOAD_MARKETPLACE_VENDOR_DETAIL_SUCESS,
  LOAD_MARKETPLACE_SIMPLY_NEXUS_SUCESS,
  LOAD_STATE_SUCCESS,
  LOAD_CATEGORY_SUCCESS,
  LOAD_ALL_VENDOR_SUCCESS,
  CLEAR_VENDOR_DETAIL,
} = ACTION_TYPES;

export default {
  LOAD_TYPE_SUCESS: LOAD_MARKETPLACE_VENDOR_TYPE_SUCCESS,
  LOAD_SUCCESS: LOAD_MARKETPLACE_VENDOR_LIST_SUCCESS,
  LOAD_ERROR: LOAD_MARKETPLACE_VENDOR_LIST_ERROR,
  LOAD_REQUEST: LOAD_MARKETPLACE_VENDOR_LIST_REQUEST,
  LOAD_VENDOR_DETAIL_SUCESS: LOAD_MARKETPLACE_VENDOR_DETAIL_SUCESS,
  LOAD_SIMPLY_NEXUS_SUCESS: LOAD_MARKETPLACE_SIMPLY_NEXUS_SUCESS,
  LOAD_STATE_SUCCESS: LOAD_STATE_SUCCESS,
  LOAD_CATEGORY_SUCCESS: LOAD_CATEGORY_SUCCESS,
  LOAD_ALL_VENDOR_SUCCESS: LOAD_ALL_VENDOR_SUCCESS,
  CLEAR_VENDOR_DETAIL: CLEAR_VENDOR_DETAIL,
};
